import { msg } from "@lingui/core/macro";
import { usePausedPatients } from "@/api/Patients";
import { PatientsTableContainer } from "./PatientsTableContainer";
import { useMemo } from "react";
import { getPatientFullName } from "@medoma/models/patients";
import { filterByNameTerms } from "@medoma/components/SearchField/searchUtils";
import { usePatientNameFilter } from "../PatientsContext";

export const PausedPatients = () => {
  const { value: filter } = usePatientNameFilter();
  const { data: patients, isPending, isError, error } = usePausedPatients({});

  const filteredPatients = useMemo(() => {
    if (!filter || !patients) {
      return patients;
    }

    return patients.filter((patient) =>
      filterByNameTerms(getPatientFullName(patient.name), filter),
    );
  }, [patients, filter]);

  const noResultsMessage =
    filteredPatients && patients && filteredPatients.length < patients.length
      ? msg`Det finns inga pausade patienter som matchar sökningen`
      : msg`Det finns inga pausade patienter`;

  return (
    <PatientsTableContainer
      patients={filteredPatients}
      isPending={isPending}
      isError={isError}
      error={error}
      additionalColumns={["admittedAt", "pausedAt"]}
      showNotifications={true}
      showPatientStatus={false}
      showPatientSignInStatus={false}
      showPrimaryResponsible={true}
      showPlaceOfAssessment={false}
      showPostDischargeProcessed={false}
      loadingMessage={msg`Hämtar pausade patienter`}
      errorMessage={msg`Kunde inte hämta pausade patienter`}
      noResultsMessage={noResultsMessage}
    />
  );
};
